// Copyright 2025, University of Maryland, All Rights Reserved
import type { FC } from 'react'
import { Switch } from '@/components/ui'

interface Props {
  detectFormatting: boolean
  onDetectFormattingChange: (value: boolean) => void
  forceExtraction: boolean
  onForceExtractionChange: (value: boolean) => void
}

export const ExtractionMethodSection: FC<Props> = ({ detectFormatting, onDetectFormattingChange, forceExtraction, onForceExtractionChange }) => (
  <div>
    <div
      className="mb-6 rounded-md border border-border bg-muted/30 p-3"
      data-testid="text-extraction-automatic"
    >
      <h3 className="text-sm font-medium">Automatic text extraction</h3>
      <p className="mt-1 text-xs text-muted-foreground">
        PyMuPDF reads embedded text first. Scan-only PDFs automatically use Tesseract OCR.
      </p>
    </div>

    <div className="mb-6">
      <h3 className="text-lg font-semibold mb-3">PyMuPDF Options</h3>
      <label className="flex cursor-pointer items-center justify-between gap-4 rounded-md border border-border p-3 hover:bg-muted/50 transition-colors">
        <div>
          <span className="block text-sm font-medium">Detect formatting</span>
          <span className="block text-xs text-muted-foreground">
            Extract underline, strikethrough, bold, and italic formatting from text.
          </span>
        </div>
        <Switch checked={detectFormatting} onCheckedChange={onDetectFormattingChange} className="flex-shrink-0" />
      </label>
    </div>

    <div>
      <h3 className="text-lg font-semibold mb-3">Cache</h3>
      <label className="flex cursor-pointer items-center justify-between gap-4 rounded-md border border-border p-3 hover:bg-muted/50 transition-colors">
        <div>
          <span className="block text-sm font-medium">Force re-extraction</span>
          <span className="block text-xs text-muted-foreground">
            Always re-extract text, even if cached results exist for a document.
          </span>
        </div>
        <Switch checked={forceExtraction} onCheckedChange={onForceExtractionChange} className="flex-shrink-0" />
      </label>
    </div>
  </div>
)
